

import { doError } from "../responseHandling/responseHandling.actions";
import OnlineSalesProcessProvider from "./onlineSalesProcess.apis";
import { doSetData, doHandleState } from "./onlineSalesProcess.actions";

import { extractDataOnlineSalesPartyAvailabilityList } from "./onlineSalesProcess.utils";

const OnlineSalesProcessService = {
  getAllDatas: (payload) => async dispatch => {
    const { acknowledge, data, message } = await OnlineSalesProcessProvider.getAllOnlineSalesPartyAvailability(payload);
    if (acknowledge && acknowledge === 1) {
      const final = extractDataOnlineSalesPartyAvailabilityList(data)
      dispatch(doHandleState('roomPartyAvailability', final))
    } else {
      dispatch(doError(message, "online party availability", 'Get List'))
    }
    dispatch(doHandleState('loading', false))

  },

};

export default OnlineSalesProcessService;
